export default "__VITE_ASSET__5bb9491e__"